<template>
  <li
    class="rs-dropdown-item"
    :class="itemClasses"
  >
    <hr
      v-if="divider"
      class="rs-dropdown-divider"
    >
    <template v-else>
      <div
        :id="`${id}_nav-link`"
        v-b-modal="id"
        :href="href"
        class="nav-link"
        @click="disabled ? '' : $emit('click')"
      >
        <RsIcon
          v-if="icon"
          :id="`${id}_icon`"
          :icon="icon"
          :weight="weight"
        />
        <span
          v-if="title"
          :id="`${id}_title`"
        >{{ title }}</span>
        <slot />
        <RsTooltip
          v-if="tooltip"
          :target="`${id}_nav-link`"
          :title="tooltip"
          position="bottom"
        />
      </div>
    </template>
  </li>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'RsDropdownItem',

  props: {
    id: {
      type: String,
      default: '',
    },
    divider: {
      type: [Boolean, String],
      default: false,
    },
    href: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    weight: {
      type: String,
      default: 'fal',
    },
    delete: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: String,
      default: '',
    },
    active: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    itemClasses(): Record<string, boolean> {
      return {
        'rs-dropdown-item--delete': this.delete,
        'rs-dropdown-item--active': this.active,
        'rs-dropdown-item--disabled': this.disabled,
      };
    },
  },
});
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
hr.rs-dropdown-divider{
  margin: 0.5rem 0.75rem;
  height: 0;
  border: none;
  overflow: hidden;
  border-top: 1px solid #e9ecef;
}

.rs-dropdown-item{
  display: flex;
  justify-content: space-between;
  align-items: center;
  .nav-link{
    display: block;
    display: flex;
    align-items: center;
    padding: 0.5rem;
    width: 100%;
    color: $tertiary-muted;
    font-size: 0.875rem;
    white-space: nowrap;
    transition: all 0.25s ease;
    cursor: pointer;
    border-radius: $global-radius;
    span{
      line-height: 1rem;
    }
    &:hover{
      color: $dark-gray;
      text-decoration: none;
      background-color: rgba($tertiary-muted, 0.1);
      i{
        color: $primary-color;
      }
    }
  }
  i{
    color: $tertiary-muted;
    margin-right: 0.35rem;
    transition: all 0.25s ease;
  }
  &--delete{
    .nav-link{
      color: $error;
      &:hover{
        color: $error;
        background-color: rgba($error, 0.1);
      }
    }
  }
  &--active {
    .nav-link{
      color: $dark-gray;
      text-decoration: none;
      background-color: rgba($tertiary-muted, 0.1);
      i{
        color: $primary-color;
      }
    }
  }
  &--disabled {
    .nav-link, .nav-link * {
      color: #a1a1a1;
      cursor: not-allowed;
    }
    .nav-link {
      background-color: #cecece4d;
    }
  }
}
</style>
